"use strict";
// Array Expression Operators: https://docs.mongodb.com/manual/reference/operator/aggregation/#array-expression-operators
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$filter = void 0;
var core_1 = require("../../../core");
var util_1 = require("../../../util");
/**
 * Selects a subset of the array to return an array with only the elements that match the filter condition.
 *
 * @param  {Object} obj  [description]
 * @param  {*} expr [description]
 * @return {*}      [description]
 */
function $filter(obj, expr, options) {
    var input = (0, core_1.computeValue)(obj, expr.input, null, options);
    (0, util_1.assert)((0, util_1.isArray)(input), "$filter 'input' expression must resolve to an array");
    var tempKey = "$" + (expr.as || "this");
    return input.filter(function (o) {
        var _a;
        return (0, core_1.computeValue)(__assign(__assign({}, obj), (_a = {}, _a[tempKey] = o, _a)), expr.cond, null, options) === true;
    });
}
exports.$filter = $filter;
